import { CHARTS, Responses } from "constants/enums";
import { IChart } from "./api";
import { ReactNode } from "react";

export interface IOption {
  label: string;
  value: string;
  icon?: ReactNode;
}

export interface HeadCell {
  disablePadding: boolean;
  id: keyof any;
  label: string;
  numeric: boolean;
  isDate?: boolean;
  isNotSortable?: boolean;
}

export interface IFormField {
  name: string;
  label?: string;
  type:
  | "text"
  | "email"
  | "password"
  | "number"
  | "date"
  | "time"
  | "datetime-local"
  | "checkbox"
  | "radio"
  | "select"
  | "hidden"
  | "multi select"
  | "image"
  | "checkboxes"
  | "editor"
  | "textarea"
  | "select with input"
  | "switch"
  | "file"
  | "color"
  | 'tel'
  | "custom field"
  | "multiple files"
  | "calender"
  | "country"
  | "phone"
  | "phone2";
  placeholder?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  maxLength?: number;
  options?: IOption[];
  defaultValue?: any;
  multiple?: boolean;
  rows?: number;
  hideLabel?: boolean;
  internalLabel?: boolean;
  cols?: number;
  fileType?:  'image' | 'other';
  yearsOnly?: boolean;
  isEditor?: boolean;
  required?: boolean;
  hidden?: boolean;
  endAdornment?: any;
  minRows?: number;
  multiline?: boolean;
  showLabel?: boolean;
  startAdornment?: any;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  grid?: number;
  disableSubmit?: boolean;
  helperText?: string;
  errorMessage?: string;
  isCustom?: boolean;
  customField?: any;
  notSavable?: boolean;
  subDefaultValue?: string;
  onDeleteFile?: () => void;
  defaultImageUrl?: string;
  isViewValue?: boolean;
  uploadedFiles?: any[];
  maxSize?: number;
  bulkAction?: Boolean;
  bulkActionLabel?: string;
  bulkActionFn?: () => void;
  isHorizontal?: boolean;
  canSelectAll?: boolean;
}

export interface IResponse {
  type:
  | Responses.SUCCESS
  | Responses.ERROR
  | Responses.WARNING
  | Responses.INFO;
  message?: string;
  data?: any;
}

export enum ELanguage {
  ENGLISH = "en",
  ARABIC = "ar",
}

export interface ICountry {
  countryName: string;
  phoneNumberCode: string;
  countryCode: string;
}


export interface ITraineeMandays {
  Level1?: string | null
  Level2?: string | null
  Level3?: string | null
  Level4?: string | null
  Level5?: string | null
  Level6?: string | null
  Level7?: string | null
  Level8?: string | null
  Level9?: string | null
  Level10?: string | null
  Value: number;
  [key: string]: any;
};

export interface IChartView {
  isLocalLabel?: boolean;
  type: CHARTS;
  hidden?: boolean;
  data: IChart;
  chartData?: any;
  drilldownData?: ITraineeMandays[];
  drilldownLevels?: number;
  isMultiple?: boolean;
  multipleData?: IChart[];
  label: string;
  backgroundColor?: string;
  borderColor?: string;
  backgroundColorPie?: string[];
  borderColorPie?: string[];
  borderWidth?: number;
  stack?: string;
  min?: number;
  max?: number;
  childrenBackgroundColor?: string;
  childrenBorderColor?: string;
  childrenBorderWidth?: number;
  childrenStack?: string;
  indexAxis?: "x" | "y";
  maxHeight?: number;
  minHeight?: number;
  maxWidth?: number;
  minWidth?: number;
  Id?: string;
  onExport?: () => void;
  seriesChildren?: any[];
  categoriesChildren?: any[];
  isPercentage?: boolean;
  onCustomDownload?: () => void;
  totalValues?: number;
}

export interface IEvaluationQuestionType {
  id: number,
  description: string,
  descriptionAr: string | undefined
}